exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports
exports.locals = {
	"menuText": "#000",
	"menuActiveText": "var(--tabbackground)",
	"subMenuActiveText": "var(--tabbackground)",
	"menuBg": "#fff",
	"menuHover": "var(--aside)",
	"subMenuBg": "var(--aside)",
	"subMenuHover": "#000",
	"sideBarWidth": "120px",
	"navbackground": "var(--navbackground, \"#409EFF\")",
	"tabbackground": "var(--tabbackground)",
	"tabfontcolor": "var(--tabfontcolor, \"black\")",
	"contentbackground": "var(--contentbackground, \"#1890ff\")",
	"contenthouverbackground": "var(--contenthouverbackground, \"#e6f7ff\")",
	"buttonhouverbackground": "var(--buttonhouverbackground, \"#fff\")",
	"aside": "aside"
};